import { useState } from 'react';

export default function WaitlistSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');

    const body = new URLSearchParams();
    body.append('email', email);

    try {
      const res = await fetch('https://readdy.ai/api/form/d762nkkbmgf2o8mm70b0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        throw new Error('fail');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section
      id="waitlist"
      className="py-[110px] px-[60px] border-t border-[#1e1a18] bg-[#060606] max-md:px-6"
      style={{ fontFamily: "'Work Sans', sans-serif" }}
    >
      <div className="max-w-[640px] mx-auto text-center">
        <h2
          className="font-black text-[#faf9f7] leading-[0.95] mb-5 tracking-[-0.01em]"
          style={{
            fontFamily: "'Big Shoulders Display', sans-serif",
            fontSize: 'clamp(42px, 6vw, 72px)',
          }}
        >
          This is what
          <br />
          I&apos;m building.
        </h2>
        <p className="text-[16px] font-light text-[#e0dbd5] leading-[1.7] mb-[44px]">
          Right now. In beta. If you&apos;d actually use this — drop your email below and
          I&apos;ll personally ping you when we&apos;re ready. I want the first people in to be
          the ones who felt this in their chest.
        </p>

        {status === 'success' ? (
          <div className="flex justify-center">
            <div className="inline-block px-[28px] py-[16px] text-[#faf9f7] text-[12px] font-bold tracking-[0.12em] uppercase" style={{ background: '#2a6e3f' }}>
              You&apos;re on the list ✓
            </div>
          </div>
        ) : (
          <form
            data-readdy-form
            id="jessica-waitlist-form"
            onSubmit={handleSubmit}
            className="flex max-w-[480px] mx-auto mb-5 flex-col sm:flex-row"
          >
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 px-5 py-4 bg-[#0d0d0d] border border-[#2a2422] sm:border-r-0 text-[#faf9f7] text-[14px] outline-none placeholder-[#4a4440] focus:border-[#ac1218] transition-colors duration-200"
              style={{ fontFamily: "'Work Sans', sans-serif" }}
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-7 py-4 bg-[#ac1218] text-[#faf9f7] text-[12px] font-bold tracking-[0.12em] uppercase border border-[#ac1218] cursor-pointer hover:bg-[#d43742] transition-colors duration-200 whitespace-nowrap disabled:opacity-60"
              style={{ fontFamily: "'Work Sans', sans-serif" }}
            >
              {status === 'loading' ? '...' : 'Join Waitlist'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-[13px] text-[#d43742] mb-4">Something went wrong. Please try again.</p>
        )}

        <p className="text-[11px] text-[#ccc7c2] tracking-[0.06em]">
          <strong className="text-[#d43742]">Building in public.</strong>&nbsp; No spam. No
          credit card. Just a ping when we&apos;re ready.
        </p>
      </div>
    </section>
  );
}
